import { useMatchAnyRoute } from "@circle-react/hooks/useMatchAnyRoute";
import { useMatchRouteWithExact } from "@circle-react/hooks/useMatchRouteWithExact";

export const useRouteHelpers = () => {
  const matchRouteWithExact = useMatchRouteWithExact();
  const matchAnyRoute = useMatchAnyRoute();

  return {
    get isSpaceRoute() {
      return Boolean(matchRouteWithExact("/c/$spaceSlug"));
    },
    get isSpaceGroupRoute() {
      return Boolean(matchRouteWithExact("/s/$spaceGroupSlug"));
    },
    get isFeedRoute() {
      return Boolean(matchRouteWithExact("/feed"));
    },
    get isHomePage() {
      return Boolean(matchRouteWithExact("/feed"));
    },
    get isSpaceShowPage() {
      return Boolean(matchRouteWithExact("/c/$spaceSlug")?.isExact);
    },
    get isMemberDirectoryPage() {
      return matchRouteWithExact("/members");
    },
    get isMessagesPage() {
      return Boolean(matchAnyRoute(["/messages/$uuid", "/messages"])?.isExact);
    },
    get isSettingsPage() {
      return Boolean(matchRouteWithExact("/settings"));
    },
    get isGettingStartedRoute() {
      return Boolean(matchRouteWithExact("/getting-started")?.isExact);
    },
    get isLivePage() {
      return Boolean(matchRouteWithExact("/live/$roomSlug"));
    },
    get isDiscoverPage() {
      return Boolean(matchRouteWithExact("/discover"));
    },
    get isPostDetailPage() {
      return matchRouteWithExact("/c/$spaceSlug/$postSlug");
    },
  };
};
